import { render } from "./report_comment.html?vue&type=template&id=1ac2dee2&scoped=true&external"
import script from "./report_comment.js?vue&type=script&lang=js&external"
export * from "./report_comment.js?vue&type=script&lang=js&external"

import "../../assets/css/new_style.css?vue&type=style&index=0&id=1ac2dee2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac2dee2"]])

export default __exports__